<template>
    <el-dialog
        :visible.sync="showPop"
        width="900px"
        :show-close="true"
        @close="$emit('input', false)"
        >
       <div style="width: 100%;">
            <div class="my-search-box">
                <div class="my-search-con">
                    <div class="my-search-con-item">
                        <span class="my-search-con-item-title">支付时间</span>
                        <el-date-picker
                            v-model="searchObj.my_time"
                            type="daterange"
                            value-format="yyyy-MM-dd"
                            :picker-options="pickerOptions"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                    </div>
                    <div class="my-search-con-item">
                        <span class="my-search-con-item-title">课程</span>
                        <el-select
                            v-model="searchObj.product_id"
                            multiple
                            collapse-tags
                            style="margin-left: 20px;width: 250px;"
                            :clearable="true"
                            placeholder="支持多选，默认全部">
                            <el-option
                                v-for="item in classList"
                                :key="item.id"
                                :label="item.title"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="my-search-con-item">
                        <el-button type="primary" @click="searchRes">查询</el-button>
                    </div>
                </div>
            </div>
            <div ref="chartDom" style="height: 400px; margin-top: 20px; background:#fff"></div>
       </div>
    </el-dialog>
</template>

<script>
    import { mapActions } from 'vuex';
    import { chartsPopOption } from './data.js'
    import dayjs from "dayjs";
    const echarts = require("echarts");
    export default {
        props: {
            value: {
                type: Boolean,
                default: false
            },
            ataid: { // 定向推广ID
                type: Number | String,
                default: ''
            }
        },
        watch:{
            value(nval){
                this.showPop = nval
                if(nval){
                    this.changeDefault()
                    this.searchRes()
                    this.getClassList(this.ataid)
                }else{
                    this.myChart && this.myChart.clear()
                    this.classList = []
                    this.searchObj.product_id = []
                }
            }
        },
        data(){
            return{
                showPop: false,
                searchObj: {
                    my_time: [],
                    product_id: []
                },
                chartOption: chartsPopOption,
                // choiceDate: '',
                pickerOptions:{
                    // onPick: ({ maxDate, minDate }) => {
                    //     this.choiceDate = minDate.getTime()
                    //     if (maxDate) {
                    //         this.choiceDate = ''
                    //     }
                    // },
                    // disabledDate: (time) => {
                    //     if ((this.choiceDate) !== '') {
                    //         const one = 30 * 24 * 3600 * 1000 // 限制30天范围
                    //         const minTime = this.choiceDate - one
                    //         const maxTime = this.choiceDate + one
                    //         return time.getTime() < minTime || time.getTime() > maxTime
                    //     }
                    // }
                },
                myChart: null,
                classList: []
            }
        },
        beforeDestroy(){
            this.myChart = null
        },
        methods: {
            ...mapActions('help',['getTargetedPromotionChartsAPI', 'appointProduct']),
            async getClassList(id){
                let res = await this.appointProduct({params: {id}})
                console.log('getClassList-res:',res)
                this.classList = res
            },
            // 修改默认时间
            changeDefault(){
                const currentDay = dayjs().format("YYYY-MM-DD"); //当日
                const lastday_90 = dayjs().subtract(30, 'day').format("YYYY-MM-DD") // 30天前
                this.searchObj.my_time = [lastday_90, currentDay]
            },
            // 点击查询
            async searchRes(){
                let params = JSON.parse(JSON.stringify(this.searchObj))
                params.start_date = params.my_time[0]
                params.end_date = params.my_time[1]
                params.product_id = params.product_id.join(',')
                params.ataid = this.ataid
                delete params.my_time
                let res = await this.getTargetedPromotionChartsAPI(params)
                console.log('searchRes-res:',res)
                this.chartOption.xAxis.data = res.date_list // x轴-日期
                this.chartOption.series[0].data = res.order_count // y轴-成交单数
                this.draw()
            },
            // 绘制图表
            draw() {
                this.$nextTick(()=>{
                    this.myChart = echarts.init(this.$refs.chartDom);
                    this.myChart.setOption(this.chartOption);
                })
            },
        }
    }
</script>

<style lang="less" scoped>
.my-search-box{
    .my-search-con{
        display: flex;
        .my-search-con-item{
            display: flex;
            align-items: center;
            margin-right: 20px;
            /deep/.el-select{
                margin-left: 0px !important;
            }
            .my-search-con-item-title{
                white-space: nowrap;
                margin-right: 10px;
            }
        }
    }
}
/deep/.el-select__tags{
  .el-select__tags-text {
    display: inline-block;
    max-width: 110px;
    @media (max-width: 1400px) {
      max-width: 42px;
    }
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .el-tag__close.el-icon-close {
    top: -7px;
    right: -4px;
  }
}
</style>